<template>
  <v-container>
    <b-card>
      <div class="d-flex justify-content-between">
        <b-card-title>لیست برند ها</b-card-title>

        <div>
          <b-button to="/brands/create" variant="primary">افزودن برند</b-button>
        </div>
      </div>
      <list-table />
    </b-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import ListTable from "./ListTable";
export default {
  name: "List",
  components: { ListTable },
  data() {
    return {};
  }
};
</script>

<style scoped></style>
